import React from "react"
import ExpansionComponent from "components/ExpansionComponent"
import EmailCard from "./EmailCard";
import Modal from "components/Modal";
import SendTest from "./sendTest";
import EditEmail from "../EditEmails"
import ImageUploader from "../../EventVenue/imageChanger";
var imagePicker;
const imagePickerInit = (ref) => {
  imagePicker = ref;
}


const EmailTab = ({ notifications, reminders, confirmations, classes, timezoneString, handleToggleEmails, orgColors, ...props }) => {
  const [expanded, setExpanded] = React.useState('Notifications');
  const [openModal, setOpen] = React.useState(false);
  const [editEmailDetails, setEditEmailDetails] = React.useState(false);

  const handleExpandedPanel = (panel) => {
    if (panel === expanded)
      setExpanded("");
    else {
      setExpanded(panel);
    }
  }

  React.useEffect(() => {
    window.parent.onEmailBannerChange = () => {
      imagePicker.handleOpen()
    }
  }, [1])




  const toggleEditClickCallback = (item) => {
    if (editEmailDetails) {
      setEditEmailDetails(false)
    } else {
      setEditEmailDetails(item)
    }

  }


  const toggleModal = (item) => {
    if (openModal) {
      setOpen(false)
    } else {
      setOpen(item)
    }
  }

  const renderEmails = (item, index) => (
    <EmailCard
      onEditClickCallback={toggleEditClickCallback}
      toggleModal={toggleModal}
      handleToggleEmails={handleToggleEmails}
      key={index}
      item={item}
      classes={classes}
      timezoneString={timezoneString} />
  )

  return (
    <>
      <ImageUploader
        onRef={imagePickerInit}
        onChange={(url) => {
          if (window.parent.afterImageChange)
            window.parent.afterImageChange(url)
        }}
        showNotification={(e) => {
          props.showNotification(e, "error")
        }}
        customButton={<></>}
      />
      {
        editEmailDetails ?
          <EditEmail
            item={editEmailDetails}
            toggleModal={toggleModal}
            handleBackCallback={toggleEditClickCallback}
            handleToggleEmails={handleToggleEmails}
            showNotification={props.showNotification}
            orgColors={orgColors}
            allEmails={[
              {
                name: "Notifications",
                children: notifications
              },
              {
                name: "Reminders",
                children: reminders
              },
              {
                name: "RSVP Confirmations",
                children: confirmations
              }
            ]}
          /> :
          <div className={classes.emailContainer}>
            <ExpansionComponent
              expanded={expanded === 'Notifications'}
              header={`Notifications(${notifications.length})`}
              name="Notifications"
              handleExpandedPanel={handleExpandedPanel}
              icon={"arrow"}
            >
              <div className={classes.emails}>
                {notifications.map(renderEmails)}
              </div>
            </ExpansionComponent>
            <div className={classes.marginTop}>
              <ExpansionComponent
                expanded={expanded === 'Reminders'}
                header={`Reminders(${reminders.length})`}
                name="Reminders"
                handleExpandedPanel={handleExpandedPanel}
                icon={"arrow"}
              >
                <div className={classes.emails}>
                  {reminders.map(renderEmails)}
                </div>
              </ExpansionComponent>
            </div>
            <div className={classes.marginTop}>
              <ExpansionComponent
                expanded={expanded === 'Confirmations'}
                header={`RSVP Confirmations(${confirmations.length})`}
                name="Confirmations"
                handleExpandedPanel={handleExpandedPanel}
                icon={"arrow"}
              >
                <div className={classes.emails}>
                  {confirmations.map(renderEmails)}
                </div>
              </ExpansionComponent>
            </div>
          </div >
      }
      {openModal ? <Modal
        open={openModal}
        maxWidth="sm"
        handleClose={toggleModal}
        title={<div className={classes.titleStyle}>Send Test</div>}
        className={{
          dialogRoot: classes.dialogRoot
        }}
      >
        <SendTest
          toggleModal={toggleModal}
          classes={classes}
          emailId={openModal.email_id}
          emailName={openModal.emailName}
          {...props} />
      </Modal> : null}

    </>
  )
}

export default EmailTab